export interface SpatialGradientDTO {
    diameter: string;
    value: number;
}
export interface MaxSARDTO {
    level: number;
    wholeBody: number;
    head: number;
}

export const SAR_OPERATING_MODES = [
    { level: 0, label: 'Normal operating mode' },
    { level: 1, label: 'First level controlled operating mode' },
    { level: 2, label: 'Second level controlled operating mode' },
];

export const sarOperatingModeLabel = (level: number) =>
    SAR_OPERATING_MODES.find((mode) => mode.level === level)?.label ??
    `Operating mode ${level}`;

export const sortByOperatingMode = <T extends MaxSARDTO>(sars: T[]) =>
    [...sars].sort((a, b) => a.level - b.level);

export const labelSarRows = <T extends MaxSARDTO>(sars: T[]) =>
    sortByOperatingMode(sars).map((sar) => ({
        ...sar,
        label:
            sars.filter((other) => other.level === sar.level).length > 1
                ? null
                : sarOperatingModeLabel(sar.level),
    }));
